// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__loQsV","item":"style_item__pM095","label":"style_label__fPW4v","info":"style_info__BrDCD","icon":"style_icon__hhAVf","infoItem":"style_infoItem__0Amt9"};